<template>
  <b-button variant="primary" block class="btn-buy" :class="[extraClass, {'disabled': disabled}]" @click="onClick">
    <div class="labels" :class="{'invisible': loading}" v-if="!disabled">
      <span class="label">{{ title }} {{ price|formatCurrency(currency) }}</span>
      <span class="sub-label">{{ subtitle }}</span>
    </div>
    <span v-else>{{ $t('pages.checkins_detail.package_banner_btn_added') }}</span>
    <b-spinner label="Loading..." class="spin" v-if="loading"/>
  </b-button>
</template>


<script>


import {mapGetters} from "vuex";

export default {
  name: 'ButtonPackage',
  emits: ['click'],
  props: {
    extraClass: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    price: {
      type: [Number, String],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('checkinDetail', ['currency']),
  },
  methods: {
    async onClick() {
      this.loading = true
      await this.wait(2000)
      await this.emitPromised('click')
      await this.wait(1000)
      this.loading = false
    }
  }
}
</script>
